import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { gtm } from '@dtna/dvs-core-dcp-client-utils/lib/utils/gtm';
import { UserAccessors } from '@dtna/dvs-support-dcp-shared-state/lib/selectors/user.selector';
import { IUserState } from '@dtna/dvs-support-dcp-shared-state/lib/models/user.model';
import { GTM, routeToGtmNameMap } from '@dtna/dvs-core-dcp-client-constants/lib/constants/routes';
import getRoutePatternFromLocation from '../utils/gtm';
import { useHostSelector } from '../store';

const getUserTypeForGtm = (user: IUserState) => {
  if (user.TANClaim) {
    if (user.TANClaim.IsRoot) {
      return GTM.USER_TYPES.DTNA_SUPERADMIN;
    }

    if (user.TANClaim.IsDtna && !user.TANClaim.IsAdmin) {
      return GTM.USER_TYPES.DTNA_SUPERUSER;
    }

    if (user.TANClaim.IsAdmin && !user.TANClaim.IsDtna) {
      return GTM.USER_TYPES.FLEET_ADMIN;
    }
  }

  return GTM.USER_TYPES.FLEET_USER;
};

const useGtmLocationWatcher = () => {
  const location = useLocation();
  const user = useHostSelector(UserAccessors.getUserState);

  useEffect(() => {
    const pathPattern = getRoutePatternFromLocation(location.pathname);
    if (!pathPattern) {
      return;
    }
    const pageName = routeToGtmNameMap.get(pathPattern);
    if (pageName) {
      const customer = user.Customer;
      setTimeout(() => gtm({
        [GTM.PROPS.PAGE_NAME]: pageName,
        [GTM.PROPS.FLEET_NAME]: customer && customer.Tan,
        [GTM.PROPS.USER_TYPE]: getUserTypeForGtm(user),
      }), 0);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  return null;
};

export default useGtmLocationWatcher;
